import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { recoverConfigSchema } from "@redotech/redo-model/recover-config";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createRecoverConfig = {
  name: "createRecoverConfig" as const,
  input: z.object({
    name: z.string(),
    schemaType: createEnum(SchemaType).optional(),
  }),
  output: recoverConfigSchema,
};
